import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";
import { EvaluateLecturer } from "./pages/EvaluateLecturer";
import { LecturersEvaluations } from "./pages/LecturersEvaluations";
import Contact from "./pages/Contact";
import React from "react";
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavbarText,
  Alert,

} from "reactstrap";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase-config";
import { lecturersState } from "./atoms";
import { useRecoilState } from "recoil";
import { AddLecturers } from "./pages/admin/AddLecturers";

function App() {
  const [lecturersList, setLecturersList] = useRecoilState(lecturersState);

  // const [loading, setLoading] = React.useState(true);

  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    ////////console.log("in use effect");
    const getLecturers = async () => {
      const lecturersCollectionRef = collection(db, "Lecturers2");
      const lecturers = await getDocs(lecturersCollectionRef);
      let list = lecturers.docs.map((doc) => {
        return {
          ...doc.data(),
          docId: doc.id,
        };
      });

      list = list.sort((a, b) => {
        //  sort by id
        return a.id - b.id;
      });
 
      setLecturersList(list);
      // setLoading(false);
    };

    try {
      getLecturers();
    } catch (error) {
      //console.log(error);
      setError(error);
    }
  }, []);

  return (
    <BrowserRouter>
      {/* <div className="container my-5"> */}
      <Header />
      <div className="container mt-20">
        {/* {loading && (
          <div className="container mt-5">
            <SpinnerLoader />
          </div>
        )} */}
        {error ? (
          <Alert color="danger">
            {"OOOPS, SOMETHING IS WRONG (PROBABLY WITH THE SERVER) TRY TO REFRESH OR TRY LATER... " +
              error}
          </Alert>
        ) : (
          <Routes>
            <Route path="/" element={<LecturersEvaluations />} />
            <Route
              path="/lecturers-evaluations"
              element={<LecturersEvaluations />}
            />
            <Route path="/evaluate-lecturer" element={<EvaluateLecturer />} />
            <Route path= "/contact" element={<Contact />} />
            <Route path="/secreto/addo" element={<AddLecturers />} />
          </Routes>
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;

function Header({ noRefCheck }) {
  return (
    <header className="mb-10">
      <div>
        <Navbar    color="dark"
    dark  container expand>
          <NavbarBrand>
        LecturersEvaluator
          </NavbarBrand>
          <NavbarToggler onClick={function noRefCheck() {}} />
          <Collapse navbar>
            <Nav className="me-auto" navbar>
              <NavItem 
              >
                <NavLink 
                className="nav-link"
                to="/">
                    Evaluations        
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="nav-link"
                to="/evaluate-lecturer"
                  >
                    Participate        
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="nav-link"
                to="/contact"
                  >
                    Contact        
                </NavLink>
              </NavItem>
            
            </Nav>
            <NavbarText color="secondary">
              Made to help
              <span role="img" aria-label="heart">
                ❤️
              </span>
            </NavbarText>
          </Collapse>
        </Navbar>
      </div>
    </header>
  );
}
